export default __webpack_public_path__ + "static/media/credit-card.f09b33b7.gif";